import { render, staticRenderFns } from "./MaterialsEdit.vue?vue&type=template&id=318b7ece&scoped=true&"
import script from "./MaterialsEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialsEdit.vue?vue&type=script&lang=js&"
import style0 from "./MaterialsEdit.vue?vue&type=style&index=0&id=318b7ece&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318b7ece",
  null
  
)

export default component.exports